import { z } from "zod";
import { BlockGenerationTaskInputSchema } from "./BlockGeneration.js";

export const AssetCompletionFactorySchema = z.object({
  factory: z.literal("asset"),
});

export const BlockGenerationFactorySchema = z
  .object({
    factory: z.literal("block"),
  })
  .extend(BlockGenerationTaskInputSchema.shape);

export const CompletionStreamInputSchema = z.object({
  prompt: z.string(),
  completion: z.discriminatedUnion("factory", [
    AssetCompletionFactorySchema,
    BlockGenerationFactorySchema,
  ]),
});

export type CompletionStreamInput = z.infer<typeof CompletionStreamInputSchema>;
export type CompletionStreamOptionsInput = CompletionStreamInput["completion"];
